import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getCurrentUserId, ingredientsCreateState, addIngredient } from 'store/storeValtio';
import { addIngredientToDb, getIngredientFromDbByIndex } from 'store/localDb';
import NumberPadModal from 'components/common/NumberPadModal';
import Select from 'components/common/Select';

var _ = require('lodash');

export default function IngredientDose({med, next}) {
  console.log('IngredientDose');
  const [submitting, setSubmitting] = useState(false);
  const [doseVal, setDoseVal] = useState('1.0');
  const [doseUnit, setDoseUnit] = useState('mg');
  const [popup, setPopup] = useState({
    show: false,
  });

  const navigate = useNavigate();
  const currentUserId = getCurrentUserId();

  const options = [
    'mcg', 'mg', 'ml', 'l'
  ];
  const defaultOption = options[1];

  function doseUnitChanged(e) {
    console.log('doseUnit', e.value);
    setDoseUnit(e.value);
  }

  function openNumberPad() {
    setPopup({show: true});
  }

  function setDose(d) {
    console.log('setDose', d);
    setDoseVal(d);
    setPopup({show: false});
  }

  function cancelDose() {
    console.log('cancelDose');
    setPopup({show: false});
  }

  function cancel() {
    next(0);
  }

  function confirm() {
    console.log('enter ingredient', doseVal, doseUnit);
    ingredientsCreateState.dose = doseVal;
    ingredientsCreateState.unit = doseUnit;

    //console.log('save ingredient', ingredientsCreateState);
    saveIngredient();
    next(0);
  }

  async function saveIngredient() {
    console.log('saveIngredient start', ingredientsCreateState);
    setSubmitting(true);
    const iId = ingredientsCreateState.DsldId;
    //const ing = await getIngredientFromDbByIndex('DsldId', iId );
    //console.log('getIngredientFromDbByIndex', ing);

    const newObj = _.cloneDeep(ingredientsCreateState);

    console.log('saveIngredient', newObj);
    await addIngredientToDb(newObj);
    addIngredient(newObj);
    setSubmitting(false);
    navigate('/ingredients/'+ newObj.medicationId);  // do this to refresh
  }


  return (
    <>
      <div className='medBody text-center'>
          What is the <b>dosage</b> of your Ingredient?
      </div>
      <div className='flex flex-row justify-center mt-4 text-2xl'>
        <NumberPadModal
            open={popup.show} 
            initialValue={doseVal}
            onConfirm={(v)=>setDose(v)}
            onCancel={()=>cancelDose()}
            />

        <div
            className="w-4/12 border-2 border-black p-2"
            onClick={()=>openNumberPad()}>{doseVal}</div>
        <Select 
            className="w-4/12 border-2 border-black"
            options={options} 
            onChange={(e)=>doseUnitChanged(e)} 
            defaultOption={defaultOption} 
            placeholder="Select a dose unit" />
      </div>
      <div className='flex justify-around mt-4 pb-1'>
        <button 
          onClick={()=>cancel()} 
          disabled={submitting}
          className='mbtn w-5/12 mr-2 bg-red-400'>
            Cancel
        </button>
        <button 
          onClick={()=>confirm()} 
          className='mbtn w-5/12 bg-green-400'>
            Enter Ingredient
        </button>
      </div>
    </>
  )
}

